import { render, staticRenderFns } from "./calendar-notes.vue?vue&type=template&id=48adf47b&"
import script from "./calendar-notes.vue?vue&type=script&lang=js&"
export * from "./calendar-notes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports